// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"192":"dacc8f68","789":"4f797092","800":"fae83720","830":"d2e8171b"}[chunkId] + ".chunk.js";
};